/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ClientBase } from './client.base';

export class Client extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        'ngInject';

        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getActionItemById(actionItemId: string): Promise<SwaggerResponse<ActionItemDto>> {
        let url_ = this.baseUrl + "/api/actionItems/{actionItemId}";
        if (actionItemId === undefined || actionItemId === null)
            throw new Error("The parameter 'actionItemId' must be defined.");
        url_ = url_.replace("{actionItemId}", encodeURIComponent("" + actionItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionItemById(_response));
        });
    }

    protected processGetActionItemById(response: Response): Promise<SwaggerResponse<ActionItemDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActionItemDto.fromJS(resultData200) : new ActionItemDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionItemDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedActionItem (optional) 
     * @return Success
     */
    updateActionItem(actionItemId: string, updatedActionItem?: ActionItemDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems/{actionItemId}";
        if (actionItemId === undefined || actionItemId === null)
            throw new Error("The parameter 'actionItemId' must be defined.");
        url_ = url_.replace("{actionItemId}", encodeURIComponent("" + actionItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedActionItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateActionItem(_response));
        });
    }

    protected processUpdateActionItem(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateActionItem(actionItemId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems/{actionItemId}";
        if (actionItemId === undefined || actionItemId === null)
            throw new Error("The parameter 'actionItemId' must be defined.");
        url_ = url_.replace("{actionItemId}", encodeURIComponent("" + actionItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateActionItem(_response));
        });
    }

    protected processReactivateActionItem(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveActionItem(actionItemId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems/{actionItemId}";
        if (actionItemId === undefined || actionItemId === null)
            throw new Error("The parameter 'actionItemId' must be defined.");
        url_ = url_.replace("{actionItemId}", encodeURIComponent("" + actionItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveActionItem(_response));
        });
    }

    protected processArchiveActionItem(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param branches (optional) 
     * @param regions (optional) 
     * @param assessments (optional) 
     * @param assignees (optional) 
     * @param filter (optional) 
     * @param filterBy30 (optional) 
     * @param filterByOverdue (optional) 
     * @param filterByCompleted (optional) 
     * @param showArchived (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllActionItems(branches?: string | null | undefined, regions?: string | null | undefined, assessments?: string | null | undefined, assignees?: string | null | undefined, filter?: string | null | undefined, filterBy30?: boolean | null | undefined, filterByOverdue?: boolean | null | undefined, filterByCompleted?: boolean | null | undefined, showArchived?: boolean | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ActionItemDto[]>> {
        let url_ = this.baseUrl + "/api/actionItems?";
        if (branches !== undefined)
            url_ += "branches=" + encodeURIComponent("" + branches) + "&"; 
        if (regions !== undefined)
            url_ += "regions=" + encodeURIComponent("" + regions) + "&"; 
        if (assessments !== undefined)
            url_ += "assessments=" + encodeURIComponent("" + assessments) + "&"; 
        if (assignees !== undefined)
            url_ += "assignees=" + encodeURIComponent("" + assignees) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (filterBy30 !== undefined)
            url_ += "filterBy30=" + encodeURIComponent("" + filterBy30) + "&"; 
        if (filterByOverdue !== undefined)
            url_ += "filterByOverdue=" + encodeURIComponent("" + filterByOverdue) + "&"; 
        if (filterByCompleted !== undefined)
            url_ += "filterByCompleted=" + encodeURIComponent("" + filterByCompleted) + "&"; 
        if (showArchived !== undefined)
            url_ += "showArchived=" + encodeURIComponent("" + showArchived) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActionItems(_response));
        });
    }

    protected processGetAllActionItems(response: Response): Promise<SwaggerResponse<ActionItemDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ActionItemDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionItemDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newActionItem (optional) 
     * @return Success
     */
    createActionItem(newActionItem?: ActionItemDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newActionItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateActionItem(_response));
        });
    }

    protected processCreateActionItem(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param noteDto (optional) 
     * @return OK
     */
    createNote(noteDto?: NoteDto | null | undefined): Promise<SwaggerResponse<NoteDto>> {
        let url_ = this.baseUrl + "/api/actionItems/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(noteDto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNote(_response));
        });
    }

    protected processCreateNote(response: Response): Promise<SwaggerResponse<NoteDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NoteDto.fromJS(resultData200) : new NoteDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<NoteDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveNote(noteId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems/note/{noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveNote(_response));
        });
    }

    protected processArchiveNote(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    sendNotificationEmail(actionItemId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionItems/{actionItemId}/sendNotificationEmail";
        if (actionItemId === undefined || actionItemId === null)
            throw new Error("The parameter 'actionItemId' must be defined.");
        url_ = url_.replace("{actionItemId}", encodeURIComponent("" + actionItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendNotificationEmail(_response));
        });
    }

    protected processSendNotificationEmail(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getActionStatusById(actionStatusId: string): Promise<SwaggerResponse<ActionStatusDto>> {
        let url_ = this.baseUrl + "/api/actionStatuses/{actionStatusId}";
        if (actionStatusId === undefined || actionStatusId === null)
            throw new Error("The parameter 'actionStatusId' must be defined.");
        url_ = url_.replace("{actionStatusId}", encodeURIComponent("" + actionStatusId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionStatusById(_response));
        });
    }

    protected processGetActionStatusById(response: Response): Promise<SwaggerResponse<ActionStatusDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActionStatusDto.fromJS(resultData200) : new ActionStatusDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionStatusDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedActionStatus (optional) 
     * @return Success
     */
    updateActionStatus(actionStatusId: string, updatedActionStatus?: ActionStatusDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionStatuses/{actionStatusId}";
        if (actionStatusId === undefined || actionStatusId === null)
            throw new Error("The parameter 'actionStatusId' must be defined.");
        url_ = url_.replace("{actionStatusId}", encodeURIComponent("" + actionStatusId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedActionStatus);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateActionStatus(_response));
        });
    }

    protected processUpdateActionStatus(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateActionStatus(actionStatusId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionStatuses/{actionStatusId}";
        if (actionStatusId === undefined || actionStatusId === null)
            throw new Error("The parameter 'actionStatusId' must be defined.");
        url_ = url_.replace("{actionStatusId}", encodeURIComponent("" + actionStatusId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateActionStatus(_response));
        });
    }

    protected processReactivateActionStatus(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveActionStatus(actionStatusId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionStatuses/{actionStatusId}";
        if (actionStatusId === undefined || actionStatusId === null)
            throw new Error("The parameter 'actionStatusId' must be defined.");
        url_ = url_.replace("{actionStatusId}", encodeURIComponent("" + actionStatusId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveActionStatus(_response));
        });
    }

    protected processArchiveActionStatus(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllActionStatuses(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ActionStatusDto[]>> {
        let url_ = this.baseUrl + "/api/actionStatuses?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActionStatuses(_response));
        });
    }

    protected processGetAllActionStatuses(response: Response): Promise<SwaggerResponse<ActionStatusDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ActionStatusDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionStatusDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newActionStatus (optional) 
     * @return Success
     */
    createActionStatus(newActionStatus?: ActionStatusDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/actionStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newActionStatus);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateActionStatus(_response));
        });
    }

    protected processCreateActionStatus(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getAffinityClusterById(affinityClusterId: string): Promise<SwaggerResponse<AffinityClusterDto>> {
        let url_ = this.baseUrl + "/api/affinityClusters/{affinityClusterId}";
        if (affinityClusterId === undefined || affinityClusterId === null)
            throw new Error("The parameter 'affinityClusterId' must be defined.");
        url_ = url_.replace("{affinityClusterId}", encodeURIComponent("" + affinityClusterId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAffinityClusterById(_response));
        });
    }

    protected processGetAffinityClusterById(response: Response): Promise<SwaggerResponse<AffinityClusterDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AffinityClusterDto.fromJS(resultData200) : new AffinityClusterDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AffinityClusterDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedAffinityCluster (optional) 
     * @return Success
     */
    updateAffinityCluster(affinityClusterId: string, updatedAffinityCluster?: AffinityClusterDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/affinityClusters/{affinityClusterId}";
        if (affinityClusterId === undefined || affinityClusterId === null)
            throw new Error("The parameter 'affinityClusterId' must be defined.");
        url_ = url_.replace("{affinityClusterId}", encodeURIComponent("" + affinityClusterId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAffinityCluster);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAffinityCluster(_response));
        });
    }

    protected processUpdateAffinityCluster(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateAffinityCluster(affinityClusterId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/affinityClusters/{affinityClusterId}";
        if (affinityClusterId === undefined || affinityClusterId === null)
            throw new Error("The parameter 'affinityClusterId' must be defined.");
        url_ = url_.replace("{affinityClusterId}", encodeURIComponent("" + affinityClusterId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateAffinityCluster(_response));
        });
    }

    protected processReactivateAffinityCluster(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveAffinityCluster(affinityClusterId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/affinityClusters/{affinityClusterId}";
        if (affinityClusterId === undefined || affinityClusterId === null)
            throw new Error("The parameter 'affinityClusterId' must be defined.");
        url_ = url_.replace("{affinityClusterId}", encodeURIComponent("" + affinityClusterId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveAffinityCluster(_response));
        });
    }

    protected processArchiveAffinityCluster(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param assessmentId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllAffinityClusters(assessmentId?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<AffinityClusterDto[]>> {
        let url_ = this.baseUrl + "/api/affinityClusters?";
        if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAffinityClusters(_response));
        });
    }

    protected processGetAllAffinityClusters(response: Response): Promise<SwaggerResponse<AffinityClusterDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AffinityClusterDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AffinityClusterDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newAffinityCluster (optional) 
     * @return Success
     */
    createAffinityCluster(newAffinityCluster?: AffinityClusterDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/affinityClusters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAffinityCluster);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAffinityCluster(_response));
        });
    }

    protected processCreateAffinityCluster(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getAssessmentById(assessmentId: string): Promise<SwaggerResponse<AssessmentDto>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssessmentById(_response));
        });
    }

    protected processGetAssessmentById(response: Response): Promise<SwaggerResponse<AssessmentDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AssessmentDto.fromJS(resultData200) : new AssessmentDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssessmentDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedAssessment (optional) 
     * @param isCompleted (optional) 
     * @param overrideUncompletedActionItems (optional) 
     * @return Success
     */
    updateAssessment(assessmentId: string, updatedAssessment?: AssessmentDto | null | undefined, isCompleted?: boolean | null | undefined, overrideUncompletedActionItems?: boolean | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}?";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&"; 
        if (overrideUncompletedActionItems !== undefined)
            url_ += "overrideUncompletedActionItems=" + encodeURIComponent("" + overrideUncompletedActionItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAssessment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAssessment(_response));
        });
    }

    protected processUpdateAssessment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateAssessment(assessmentId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateAssessment(_response));
        });
    }

    protected processReactivateAssessment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveAssessment(assessmentId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveAssessment(_response));
        });
    }

    protected processArchiveAssessment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedAssessmentBehavior (optional) 
     * @return Success
     */
    updateAssessmentBehavior(behaviorId: string, assessmentId: string, updatedAssessmentBehavior?: BehaviorDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/behaviors/{behaviorId}";
        if (behaviorId === undefined || behaviorId === null)
            throw new Error("The parameter 'behaviorId' must be defined.");
        url_ = url_.replace("{behaviorId}", encodeURIComponent("" + behaviorId)); 
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAssessmentBehavior);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAssessmentBehavior(_response));
        });
    }

    protected processUpdateAssessmentBehavior(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    deleteAssessmentBehavior(behaviorId: string, assessmentId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/behaviors/{behaviorId}";
        if (behaviorId === undefined || behaviorId === null)
            throw new Error("The parameter 'behaviorId' must be defined.");
        url_ = url_.replace("{behaviorId}", encodeURIComponent("" + behaviorId)); 
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAssessmentBehavior(_response));
        });
    }

    protected processDeleteAssessmentBehavior(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedAssessmentStep (optional) 
     * @return Success
     */
    updateAssessmentStep(stepId: string, assessmentId: string, updatedAssessmentStep?: StepDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/steps/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId)); 
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAssessmentStep);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAssessmentStep(_response));
        });
    }

    protected processUpdateAssessmentStep(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    deleteAssessmentStep(stepId: string, assessmentId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/steps/{stepId}";
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId)); 
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAssessmentStep(_response));
        });
    }

    protected processDeleteAssessmentStep(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param regions (optional) 
     * @param observers (optional) 
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param showCompleted (optional) 
     * @param showVisitEnded (optional) 
     * @return OK
     */
    getAllAssessments(regions?: string | null | undefined, observers?: string | null | undefined, filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, showCompleted?: boolean | null | undefined, showVisitEnded?: boolean | null | undefined): Promise<SwaggerResponse<AssessmentDto[]>> {
        let url_ = this.baseUrl + "/api/assessments?";
        if (regions !== undefined)
            url_ += "regions=" + encodeURIComponent("" + regions) + "&"; 
        if (observers !== undefined)
            url_ += "observers=" + encodeURIComponent("" + observers) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (showCompleted !== undefined)
            url_ += "showCompleted=" + encodeURIComponent("" + showCompleted) + "&"; 
        if (showVisitEnded !== undefined)
            url_ += "showVisitEnded=" + encodeURIComponent("" + showVisitEnded) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAssessments(_response));
        });
    }

    protected processGetAllAssessments(response: Response): Promise<SwaggerResponse<AssessmentDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AssessmentDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssessmentDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newAssessment (optional) 
     * @return Success
     */
    createAssessment(newAssessment?: AssessmentDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAssessment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAssessment(_response));
        });
    }

    protected processCreateAssessment(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newAssessmentBehavior (optional) 
     * @return Success
     */
    createAssessmentBehavior(assessmentId: string, newAssessmentBehavior?: BehaviorDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/behaviors";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAssessmentBehavior);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAssessmentBehavior(_response));
        });
    }

    protected processCreateAssessmentBehavior(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newAssessmentStep (optional) 
     * @return Success
     */
    createAssessmentStep(assessmentId: string, newAssessmentStep?: StepDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/steps";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAssessmentStep);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAssessmentStep(_response));
        });
    }

    protected processCreateAssessmentStep(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiAssessmentReportByAssessmentIdPdfGet(assessmentId: string): Promise<SwaggerResponse<File>> {
        let url_ = this.baseUrl + "/api/assessmentReport/{assessmentId}/pdf";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiAssessmentReportByAssessmentIdPdfGet(_response));
        });
    }

    protected processApiAssessmentReportByAssessmentIdPdfGet(response: Response): Promise<SwaggerResponse<File>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? File.fromJS(resultData200) : new File();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<File>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiAssessmentReportByAssessmentIdExcelGet(assessmentId: string): Promise<SwaggerResponse<File>> {
        let url_ = this.baseUrl + "/api/assessmentReport/{assessmentId}/excel";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiAssessmentReportByAssessmentIdExcelGet(_response));
        });
    }

    protected processApiAssessmentReportByAssessmentIdExcelGet(response: Response): Promise<SwaggerResponse<File>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? File.fromJS(resultData200) : new File();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<File>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getObserversOnExistingAssessments(): Promise<SwaggerResponse<ObserverDto[]>> {
        let url_ = this.baseUrl + "/api/assessmentObservers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetObserversOnExistingAssessments(_response));
        });
    }

    protected processGetObserversOnExistingAssessments(response: Response): Promise<SwaggerResponse<ObserverDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ObserverDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ObserverDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getAssessmentProcessById(assessmentId: string): Promise<SwaggerResponse<AssessmentProcessDto>> {
        let url_ = this.baseUrl + "/api/assessments/{assessmentId}/chevrons";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssessmentProcessById(_response));
        });
    }

    protected processGetAssessmentProcessById(response: Response): Promise<SwaggerResponse<AssessmentProcessDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AssessmentProcessDto.fromJS(resultData200) : new AssessmentProcessDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssessmentProcessDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getAssessmentsByTargetBranchId(targetBranchId: string): Promise<SwaggerResponse<AssessmentDto[]>> {
        let url_ = this.baseUrl + "/api/assessments/targetBranch/{targetBranchId}";
        if (targetBranchId === undefined || targetBranchId === null)
            throw new Error("The parameter 'targetBranchId' must be defined.");
        url_ = url_.replace("{targetBranchId}", encodeURIComponent("" + targetBranchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssessmentsByTargetBranchId(_response));
        });
    }

    protected processGetAssessmentsByTargetBranchId(response: Response): Promise<SwaggerResponse<AssessmentDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AssessmentDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AssessmentDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param branches (optional) 
     * @param regions (optional) 
     * @param assessmentId (optional) 
     * @return OK
     */
    getAssessmentDashboardStats(branches?: string | null | undefined, regions?: string | null | undefined, assessmentId?: string | null | undefined): Promise<SwaggerResponse<DashboardObservationStatsDto>> {
        let url_ = this.baseUrl + "/api/assessments/assessmentDashboard?";
        if (branches !== undefined)
            url_ += "branches=" + encodeURIComponent("" + branches) + "&"; 
        if (regions !== undefined)
            url_ += "regions=" + encodeURIComponent("" + regions) + "&"; 
        if (assessmentId !== undefined)
            url_ += "assessmentId=" + encodeURIComponent("" + assessmentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssessmentDashboardStats(_response));
        });
    }

    protected processGetAssessmentDashboardStats(response: Response): Promise<SwaggerResponse<DashboardObservationStatsDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardObservationStatsDto.fromJS(resultData200) : new DashboardObservationStatsDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<DashboardObservationStatsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedAttachmentFile (optional) 
     * @return Success
     */
    updateAttachmentFile(attachmentFileId: string, updatedAttachmentFile?: AttachmentFileDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/attachmentFiles/{attachmentFileId}";
        if (attachmentFileId === undefined || attachmentFileId === null)
            throw new Error("The parameter 'attachmentFileId' must be defined.");
        url_ = url_.replace("{attachmentFileId}", encodeURIComponent("" + attachmentFileId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedAttachmentFile);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAttachmentFile(_response));
        });
    }

    protected processUpdateAttachmentFile(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateAttachmentFile(attachmentFileId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/attachmentFiles/{attachmentFileId}";
        if (attachmentFileId === undefined || attachmentFileId === null)
            throw new Error("The parameter 'attachmentFileId' must be defined.");
        url_ = url_.replace("{attachmentFileId}", encodeURIComponent("" + attachmentFileId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateAttachmentFile(_response));
        });
    }

    protected processReactivateAttachmentFile(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveAttachmentFile(attachmentFileId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/attachmentFiles/{attachmentFileId}";
        if (attachmentFileId === undefined || attachmentFileId === null)
            throw new Error("The parameter 'attachmentFileId' must be defined.");
        url_ = url_.replace("{attachmentFileId}", encodeURIComponent("" + attachmentFileId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveAttachmentFile(_response));
        });
    }

    protected processArchiveAttachmentFile(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllAttachmentFiles(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<AttachmentFileDto[]>> {
        let url_ = this.baseUrl + "/api/attachmentFiles?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAttachmentFiles(_response));
        });
    }

    protected processGetAllAttachmentFiles(response: Response): Promise<SwaggerResponse<AttachmentFileDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AttachmentFileDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AttachmentFileDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newAttachmentFile (optional) 
     * @return Success
     */
    createAttachmentFile(newAttachmentFile?: AttachmentFileDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/attachmentFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAttachmentFile);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAttachmentFile(_response));
        });
    }

    protected processCreateAttachmentFile(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param attachmentFile (optional) 
     * @param folder (optional) 
     * @return Success
     */
    uploadAttachmentFile(attachmentFile?: AttachmentFileDto | null | undefined, folder?: string | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/upload/attachmentFile?";
        if (folder !== undefined)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentFile);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachmentFile(_response));
        });
    }

    protected processUploadAttachmentFile(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getBestPracticeById(bestpracticeId: string): Promise<SwaggerResponse<BestPracticeDto>> {
        let url_ = this.baseUrl + "/api/bestpractices/{bestpracticeId}";
        if (bestpracticeId === undefined || bestpracticeId === null)
            throw new Error("The parameter 'bestpracticeId' must be defined.");
        url_ = url_.replace("{bestpracticeId}", encodeURIComponent("" + bestpracticeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBestPracticeById(_response));
        });
    }

    protected processGetBestPracticeById(response: Response): Promise<SwaggerResponse<BestPracticeDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BestPracticeDto.fromJS(resultData200) : new BestPracticeDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BestPracticeDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedBestPractice (optional) 
     * @return Success
     */
    updateBestPractice(bestpracticeId: string, updatedBestPractice?: BestPracticeDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/bestpractices/{bestpracticeId}";
        if (bestpracticeId === undefined || bestpracticeId === null)
            throw new Error("The parameter 'bestpracticeId' must be defined.");
        url_ = url_.replace("{bestpracticeId}", encodeURIComponent("" + bestpracticeId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedBestPractice);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBestPractice(_response));
        });
    }

    protected processUpdateBestPractice(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateBestPractice(bestpracticeId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/bestpractices/{bestpracticeId}";
        if (bestpracticeId === undefined || bestpracticeId === null)
            throw new Error("The parameter 'bestpracticeId' must be defined.");
        url_ = url_.replace("{bestpracticeId}", encodeURIComponent("" + bestpracticeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateBestPractice(_response));
        });
    }

    protected processReactivateBestPractice(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveBestPractice(bestpracticeId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/bestpractices/{bestpracticeId}";
        if (bestpracticeId === undefined || bestpracticeId === null)
            throw new Error("The parameter 'bestpracticeId' must be defined.");
        url_ = url_.replace("{bestpracticeId}", encodeURIComponent("" + bestpracticeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveBestPractice(_response));
        });
    }

    protected processArchiveBestPractice(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllBestPractices(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<BestPracticeDto[]>> {
        let url_ = this.baseUrl + "/api/bestpractices?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllBestPractices(_response));
        });
    }

    protected processGetAllBestPractices(response: Response): Promise<SwaggerResponse<BestPracticeDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BestPracticeDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BestPracticeDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newBestPractice (optional) 
     * @return Success
     */
    createBestPractice(newBestPractice?: BestPracticeDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/bestpractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newBestPractice);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateBestPractice(_response));
        });
    }

    protected processCreateBestPractice(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param bestPractice (optional) 
     * @return Success
     */
    deleteBestPractice(bestPractice?: BestPracticeDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/delete/bestPractice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bestPractice);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBestPractice(_response));
        });
    }

    protected processDeleteBestPractice(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getBranchById(branchId: string): Promise<SwaggerResponse<BranchDto>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBranchById(_response));
        });
    }

    protected processGetBranchById(response: Response): Promise<SwaggerResponse<BranchDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchDto.fromJS(resultData200) : new BranchDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BranchDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedBranch (optional) 
     * @return Success
     */
    updateBranch(branchId: string, updatedBranch?: BranchDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedBranch);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBranch(_response));
        });
    }

    protected processUpdateBranch(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateBranch(branchId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateBranch(_response));
        });
    }

    protected processReactivateBranch(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveBranch(branchId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveBranch(_response));
        });
    }

    protected processArchiveBranch(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param regionsFilter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllBranches(filter?: string | null | undefined, regionsFilter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<BranchDto[]>> {
        let url_ = this.baseUrl + "/api/branches?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (regionsFilter !== undefined)
            url_ += "regionsFilter=" + encodeURIComponent("" + regionsFilter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllBranches(_response));
        });
    }

    protected processGetAllBranches(response: Response): Promise<SwaggerResponse<BranchDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BranchDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BranchDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newBranch (optional) 
     * @return Success
     */
    createBranch(newBranch?: BranchDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newBranch);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateBranch(_response));
        });
    }

    protected processCreateBranch(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getBranchKpiById(branchKpiId: string, branchId: string): Promise<SwaggerResponse<BranchKpiDto>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpis/{branchKpiId}";
        if (branchKpiId === undefined || branchKpiId === null)
            throw new Error("The parameter 'branchKpiId' must be defined.");
        url_ = url_.replace("{branchKpiId}", encodeURIComponent("" + branchKpiId)); 
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBranchKpiById(_response));
        });
    }

    protected processGetBranchKpiById(response: Response): Promise<SwaggerResponse<BranchKpiDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchKpiDto.fromJS(resultData200) : new BranchKpiDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BranchKpiDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedBranchKpi (optional) 
     * @return Success
     */
    updateBranchKpi(branchKpiId: string, branchId: string, updatedBranchKpi?: BranchKpiDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpis/{branchKpiId}";
        if (branchKpiId === undefined || branchKpiId === null)
            throw new Error("The parameter 'branchKpiId' must be defined.");
        url_ = url_.replace("{branchKpiId}", encodeURIComponent("" + branchKpiId)); 
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedBranchKpi);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBranchKpi(_response));
        });
    }

    protected processUpdateBranchKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateBranchKpi(branchKpiId: string, branchId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpis/{branchKpiId}";
        if (branchKpiId === undefined || branchKpiId === null)
            throw new Error("The parameter 'branchKpiId' must be defined.");
        url_ = url_.replace("{branchKpiId}", encodeURIComponent("" + branchKpiId)); 
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateBranchKpi(_response));
        });
    }

    protected processReactivateBranchKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveBranchKpi(branchKpiId: string, branchId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpis/{branchKpiId}";
        if (branchKpiId === undefined || branchKpiId === null)
            throw new Error("The parameter 'branchKpiId' must be defined.");
        url_ = url_.replace("{branchKpiId}", encodeURIComponent("" + branchKpiId)); 
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveBranchKpi(_response));
        });
    }

    protected processArchiveBranchKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllBranchKpis(branchId: string, filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<BranchKpiDto[]>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpi?";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllBranchKpis(_response));
        });
    }

    protected processGetAllBranchKpis(response: Response): Promise<SwaggerResponse<BranchKpiDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BranchKpiDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<BranchKpiDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newBranchKpi (optional) 
     * @return Success
     */
    createBranchKpi(branchId: string, newBranchKpi?: BranchKpiDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/branches/{branchId}/kpi";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newBranchKpi);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateBranchKpi(_response));
        });
    }

    protected processCreateBranchKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getChevronById(chevronId: string): Promise<SwaggerResponse<ChevronDto>> {
        let url_ = this.baseUrl + "/api/chevrons/{chevronId}";
        if (chevronId === undefined || chevronId === null)
            throw new Error("The parameter 'chevronId' must be defined.");
        url_ = url_.replace("{chevronId}", encodeURIComponent("" + chevronId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChevronById(_response));
        });
    }

    protected processGetChevronById(response: Response): Promise<SwaggerResponse<ChevronDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChevronDto.fromJS(resultData200) : new ChevronDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ChevronDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedChevron (optional) 
     * @return Success
     */
    updateChevron(chevronId: string, updatedChevron?: ChevronDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/chevrons/{chevronId}";
        if (chevronId === undefined || chevronId === null)
            throw new Error("The parameter 'chevronId' must be defined.");
        url_ = url_.replace("{chevronId}", encodeURIComponent("" + chevronId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedChevron);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateChevron(_response));
        });
    }

    protected processUpdateChevron(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateChevron(chevronId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/chevrons/{chevronId}";
        if (chevronId === undefined || chevronId === null)
            throw new Error("The parameter 'chevronId' must be defined.");
        url_ = url_.replace("{chevronId}", encodeURIComponent("" + chevronId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateChevron(_response));
        });
    }

    protected processReactivateChevron(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveChevron(chevronId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/chevrons/{chevronId}";
        if (chevronId === undefined || chevronId === null)
            throw new Error("The parameter 'chevronId' must be defined.");
        url_ = url_.replace("{chevronId}", encodeURIComponent("" + chevronId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveChevron(_response));
        });
    }

    protected processArchiveChevron(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllChevrons(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ChevronDto[]>> {
        let url_ = this.baseUrl + "/api/chevrons?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllChevrons(_response));
        });
    }

    protected processGetAllChevrons(response: Response): Promise<SwaggerResponse<ChevronDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ChevronDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ChevronDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newChevron (optional) 
     * @return Success
     */
    createChevron(newChevron?: ChevronDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/chevrons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newChevron);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateChevron(_response));
        });
    }

    protected processCreateChevron(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param subType (optional) 
     * @return Success
     */
    apiColumnSettingsByUserIdByTypeGet(userId: string, type: string, subType?: string | null | undefined): Promise<SwaggerResponse<ColumnSettingsDto[]>> {
        let url_ = this.baseUrl + "/api/ColumnSettings/{userId}/{type}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        if (subType !== undefined)
            url_ += "subType=" + encodeURIComponent("" + subType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiColumnSettingsByUserIdByTypeGet(_response));
        });
    }

    protected processApiColumnSettingsByUserIdByTypeGet(response: Response): Promise<SwaggerResponse<ColumnSettingsDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ColumnSettingsDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ColumnSettingsDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param columnSettings (optional) 
     * @param subType (optional) 
     * @return Success
     */
    apiColumnSettingsByUserIdByTypePut(userId: string, type: string, columnSettings?: ColumnSettingsDto[] | null | undefined, subType?: string | null | undefined): Promise<SwaggerResponse<ColumnSettingsDto>> {
        let url_ = this.baseUrl + "/api/ColumnSettings/{userId}/{type}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type)); 
        if (subType !== undefined)
            url_ += "subType=" + encodeURIComponent("" + subType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(columnSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiColumnSettingsByUserIdByTypePut(_response));
        });
    }

    protected processApiColumnSettingsByUserIdByTypePut(response: Response): Promise<SwaggerResponse<ColumnSettingsDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ColumnSettingsDto.fromJS(resultData200) : new ColumnSettingsDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ColumnSettingsDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiFilesByMimeFileByFullPathAndFilenameGet(mime: string, fullPathAndFilename: string): Promise<SwaggerResponse<File>> {
        let url_ = this.baseUrl + "/api/Files/{mime}/file/{fullPathAndFilename}";
        if (mime === undefined || mime === null)
            throw new Error("The parameter 'mime' must be defined.");
        url_ = url_.replace("{mime}", encodeURIComponent("" + mime)); 
        if (fullPathAndFilename === undefined || fullPathAndFilename === null)
            throw new Error("The parameter 'fullPathAndFilename' must be defined.");
        url_ = url_.replace("{fullPathAndFilename}", encodeURIComponent("" + fullPathAndFilename)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiFilesByMimeFileByFullPathAndFilenameGet(_response));
        });
    }

    protected processApiFilesByMimeFileByFullPathAndFilenameGet(response: Response): Promise<SwaggerResponse<File>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? File.fromJS(resultData200) : new File();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<File>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiImagesByMimeFileByFullPathAndFilenameGet(mime: string, fullPathAndFilename: string): Promise<SwaggerResponse<File>> {
        let url_ = this.baseUrl + "/api/Images/{mime}/file/{fullPathAndFilename}";
        if (mime === undefined || mime === null)
            throw new Error("The parameter 'mime' must be defined.");
        url_ = url_.replace("{mime}", encodeURIComponent("" + mime)); 
        if (fullPathAndFilename === undefined || fullPathAndFilename === null)
            throw new Error("The parameter 'fullPathAndFilename' must be defined.");
        url_ = url_.replace("{fullPathAndFilename}", encodeURIComponent("" + fullPathAndFilename)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiImagesByMimeFileByFullPathAndFilenameGet(_response));
        });
    }

    protected processApiImagesByMimeFileByFullPathAndFilenameGet(response: Response): Promise<SwaggerResponse<File>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? File.fromJS(resultData200) : new File();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<File>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getKpiById(kpiId: string): Promise<SwaggerResponse<KpiDto>> {
        let url_ = this.baseUrl + "/api/kpis/{kpiId}";
        if (kpiId === undefined || kpiId === null)
            throw new Error("The parameter 'kpiId' must be defined.");
        url_ = url_.replace("{kpiId}", encodeURIComponent("" + kpiId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKpiById(_response));
        });
    }

    protected processGetKpiById(response: Response): Promise<SwaggerResponse<KpiDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? KpiDto.fromJS(resultData200) : new KpiDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<KpiDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedKpi (optional) 
     * @return Success
     */
    updateKpi(kpiId: string, updatedKpi?: KpiDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/kpis/{kpiId}";
        if (kpiId === undefined || kpiId === null)
            throw new Error("The parameter 'kpiId' must be defined.");
        url_ = url_.replace("{kpiId}", encodeURIComponent("" + kpiId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedKpi);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateKpi(_response));
        });
    }

    protected processUpdateKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateKpi(kpiId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/kpis/{kpiId}";
        if (kpiId === undefined || kpiId === null)
            throw new Error("The parameter 'kpiId' must be defined.");
        url_ = url_.replace("{kpiId}", encodeURIComponent("" + kpiId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateKpi(_response));
        });
    }

    protected processReactivateKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveKpi(kpiId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/kpis/{kpiId}";
        if (kpiId === undefined || kpiId === null)
            throw new Error("The parameter 'kpiId' must be defined.");
        url_ = url_.replace("{kpiId}", encodeURIComponent("" + kpiId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveKpi(_response));
        });
    }

    protected processArchiveKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllKpis(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<KpiDto[]>> {
        let url_ = this.baseUrl + "/api/kpis?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllKpis(_response));
        });
    }

    protected processGetAllKpis(response: Response): Promise<SwaggerResponse<KpiDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(KpiDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<KpiDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newKpi (optional) 
     * @return Success
     */
    createKpi(newKpi?: KpiDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/kpis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newKpi);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateKpi(_response));
        });
    }

    protected processCreateKpi(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllKpiTypes(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<KpiTypeDto[]>> {
        let url_ = this.baseUrl + "/api/kpitypes?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllKpiTypes(_response));
        });
    }

    protected processGetAllKpiTypes(response: Response): Promise<SwaggerResponse<KpiTypeDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(KpiTypeDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<KpiTypeDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param login (optional) 
     * @return Success
     */
    apiLoginPut(login?: LoginDto | null | undefined): Promise<SwaggerResponse<LoginDto>> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginPut(_response));
        });
    }

    protected processApiLoginPut(response: Response): Promise<SwaggerResponse<LoginDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<LoginDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    apiLoginPost(model?: LoginDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginPost(_response));
        });
    }

    protected processApiLoginPost(response: Response): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiLoginDelete(): Promise<SwaggerResponse<LoginDto>> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginDelete(_response));
        });
    }

    protected processApiLoginDelete(response: Response): Promise<SwaggerResponse<LoginDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<LoginDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param userName (optional) 
     * @param resetToken (optional) 
     * @return Success
     */
    apiLoginTokenValidityPost(userName?: string | null | undefined, resetToken?: string | null | undefined): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/Login/TokenValidity?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (resetToken !== undefined)
            url_ += "resetToken=" + encodeURIComponent("" + resetToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginTokenValidityPost(_response));
        });
    }

    protected processApiLoginTokenValidityPost(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    apiLoginForgotPasswordPost(model?: LoginDto | null | undefined): Promise<SwaggerResponse<LoginDto>> {
        let url_ = this.baseUrl + "/api/Login/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginForgotPasswordPost(_response));
        });
    }

    protected processApiLoginForgotPasswordPost(response: Response): Promise<SwaggerResponse<LoginDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LoginDto.fromJS(resultData200) : new LoginDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<LoginDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiLoginCheckGet(): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Login/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiLoginCheckGet(_response));
        });
    }

    protected processApiLoginCheckGet(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getObservationById(observationId: string): Promise<SwaggerResponse<ObservationDto>> {
        let url_ = this.baseUrl + "/api/observations/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetObservationById(_response));
        });
    }

    protected processGetObservationById(response: Response): Promise<SwaggerResponse<ObservationDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ObservationDto.fromJS(resultData200) : new ObservationDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ObservationDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedObservation (optional) 
     * @return Success
     */
    updateObservation(observationId: string, updatedObservation?: ObservationDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/observations/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedObservation);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateObservation(_response));
        });
    }

    protected processUpdateObservation(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateObservation(observationId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/observations/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateObservation(_response));
        });
    }

    protected processReactivateObservation(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveObservation(observationId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/observations/{observationId}";
        if (observationId === undefined || observationId === null)
            throw new Error("The parameter 'observationId' must be defined.");
        url_ = url_.replace("{observationId}", encodeURIComponent("" + observationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveObservation(_response));
        });
    }

    protected processArchiveObservation(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param behaviorId (optional) 
     * @param types (optional) 
     * @param filter (optional) 
     * @param includeAllObservers (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllObservations(behaviorId?: string | null | undefined, types?: string | null | undefined, filter?: string | null | undefined, includeAllObservers?: boolean | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ObservationDto[]>> {
        let url_ = this.baseUrl + "/api/observations?";
        if (behaviorId !== undefined)
            url_ += "behaviorId=" + encodeURIComponent("" + behaviorId) + "&"; 
        if (types !== undefined)
            url_ += "types=" + encodeURIComponent("" + types) + "&"; 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (includeAllObservers !== undefined)
            url_ += "includeAllObservers=" + encodeURIComponent("" + includeAllObservers) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllObservations(_response));
        });
    }

    protected processGetAllObservations(response: Response): Promise<SwaggerResponse<ObservationDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ObservationDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ObservationDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newObservation (optional) 
     * @return Success
     */
    createObservation(newObservation?: ObservationDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/observations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newObservation);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateObservation(_response));
        });
    }

    protected processCreateObservation(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param includeAllObservers (optional) 
     * @param unattachedToClusterOnly (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getObservationsByAssessmentId(assessmentId: string, filter?: string | null | undefined, includeAllObservers?: boolean | null | undefined, unattachedToClusterOnly?: boolean | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ObservationDto[]>> {
        let url_ = this.baseUrl + "/api/observations/assessment/{assessmentId}?";
        if (assessmentId === undefined || assessmentId === null)
            throw new Error("The parameter 'assessmentId' must be defined.");
        url_ = url_.replace("{assessmentId}", encodeURIComponent("" + assessmentId)); 
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (includeAllObservers !== undefined)
            url_ += "includeAllObservers=" + encodeURIComponent("" + includeAllObservers) + "&"; 
        if (unattachedToClusterOnly !== undefined)
            url_ += "unattachedToClusterOnly=" + encodeURIComponent("" + unattachedToClusterOnly) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetObservationsByAssessmentId(_response));
        });
    }

    protected processGetObservationsByAssessmentId(response: Response): Promise<SwaggerResponse<ObservationDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ObservationDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ObservationDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllObservationTypes(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<ObservationTypeDto[]>> {
        let url_ = this.baseUrl + "/api/observationtypes?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllObservationTypes(_response));
        });
    }

    protected processGetAllObservationTypes(response: Response): Promise<SwaggerResponse<ObservationTypeDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ObservationTypeDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ObservationTypeDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllOrganizations(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<OrganizationDto[]>> {
        let url_ = this.baseUrl + "/api/organizations?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllOrganizations(_response));
        });
    }

    protected processGetAllOrganizations(response: Response): Promise<SwaggerResponse<OrganizationDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(OrganizationDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<OrganizationDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiPasswordRulesGet(): Promise<SwaggerResponse<PasswordRuleSettings>> {
        let url_ = this.baseUrl + "/api/PasswordRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiPasswordRulesGet(_response));
        });
    }

    protected processApiPasswordRulesGet(response: Response): Promise<SwaggerResponse<PasswordRuleSettings>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PasswordRuleSettings.fromJS(resultData200) : new PasswordRuleSettings();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PasswordRuleSettings>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getRegionById(regionId: string): Promise<SwaggerResponse<RegionDto>> {
        let url_ = this.baseUrl + "/api/regions/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRegionById(_response));
        });
    }

    protected processGetRegionById(response: Response): Promise<SwaggerResponse<RegionDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegionDto.fromJS(resultData200) : new RegionDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<RegionDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedRegion (optional) 
     * @return Success
     */
    updateRegion(regionId: string, updatedRegion?: RegionDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/regions/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedRegion);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRegion(_response));
        });
    }

    protected processUpdateRegion(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateRegion(regionId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/regions/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateRegion(_response));
        });
    }

    protected processReactivateRegion(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveRegion(regionId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/regions/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveRegion(_response));
        });
    }

    protected processArchiveRegion(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllRegions(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<RegionDto[]>> {
        let url_ = this.baseUrl + "/api/regions?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRegions(_response));
        });
    }

    protected processGetAllRegions(response: Response): Promise<SwaggerResponse<RegionDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RegionDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<RegionDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newRegion (optional) 
     * @return Success
     */
    createRegion(newRegion?: RegionDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/regions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRegion);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateRegion(_response));
        });
    }

    protected processCreateRegion(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getAllRegionNames(): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/regionNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRegionNames(_response));
        });
    }

    protected processGetAllRegionNames(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    getAllUserChampionRegions(userId?: string | null | undefined): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/userChampionRegions?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllUserChampionRegions(_response));
        });
    }

    protected processGetAllUserChampionRegions(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return OK
     */
    getRejectionFormById(rejectionFormId: string): Promise<SwaggerResponse<RejectionFormDto>> {
        let url_ = this.baseUrl + "/api/rejectionForms/{rejectionFormId}";
        if (rejectionFormId === undefined || rejectionFormId === null)
            throw new Error("The parameter 'rejectionFormId' must be defined.");
        url_ = url_.replace("{rejectionFormId}", encodeURIComponent("" + rejectionFormId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRejectionFormById(_response));
        });
    }

    protected processGetRejectionFormById(response: Response): Promise<SwaggerResponse<RejectionFormDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RejectionFormDto.fromJS(resultData200) : new RejectionFormDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<RejectionFormDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param updatedRejectionForm (optional) 
     * @return Success
     */
    updateRejectionForm(rejectionFormId: string, updatedRejectionForm?: RejectionFormDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/rejectionForms/{rejectionFormId}";
        if (rejectionFormId === undefined || rejectionFormId === null)
            throw new Error("The parameter 'rejectionFormId' must be defined.");
        url_ = url_.replace("{rejectionFormId}", encodeURIComponent("" + rejectionFormId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedRejectionForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRejectionForm(_response));
        });
    }

    protected processUpdateRejectionForm(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    reactivateRejectionForm(rejectionFormId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/rejectionForms/{rejectionFormId}";
        if (rejectionFormId === undefined || rejectionFormId === null)
            throw new Error("The parameter 'rejectionFormId' must be defined.");
        url_ = url_.replace("{rejectionFormId}", encodeURIComponent("" + rejectionFormId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReactivateRejectionForm(_response));
        });
    }

    protected processReactivateRejectionForm(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    archiveRejectionForm(rejectionFormId: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/rejectionForms/{rejectionFormId}";
        if (rejectionFormId === undefined || rejectionFormId === null)
            throw new Error("The parameter 'rejectionFormId' must be defined.");
        url_ = url_.replace("{rejectionFormId}", encodeURIComponent("" + rejectionFormId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveRejectionForm(_response));
        });
    }

    protected processArchiveRejectionForm(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @return OK
     */
    getAllRejectionForms(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined): Promise<SwaggerResponse<RejectionFormDto[]>> {
        let url_ = this.baseUrl + "/api/rejectionForms?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllRejectionForms(_response));
        });
    }

    protected processGetAllRejectionForms(response: Response): Promise<SwaggerResponse<RejectionFormDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RejectionFormDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<RejectionFormDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param newRejectionForm (optional) 
     * @return Success
     */
    createRejectionForm(newRejectionForm?: RejectionFormDto | null | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/rejectionForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRejectionForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateRejectionForm(_response));
        });
    }

    protected processCreateRejectionForm(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @return Success
     */
    apiRolesGet(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined): Promise<SwaggerResponse<RoleDto[]>> {
        let url_ = this.baseUrl + "/api/Roles?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiRolesGet(_response));
        });
    }

    protected processApiRolesGet(response: Response): Promise<SwaggerResponse<RoleDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RoleDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<RoleDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     * @param includeInactives (optional) 
     * @param roleName (optional) 
     * @return Success
     */
    apiUsersGet(filter?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, orderBy?: string | null | undefined, includeInactives?: boolean | null | undefined, roleName?: string | null | undefined): Promise<SwaggerResponse<UserDto[]>> {
        let url_ = this.baseUrl + "/api/Users?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&"; 
        if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&"; 
        if (roleName !== undefined)
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersGet(_response));
        });
    }

    protected processApiUsersGet(response: Response): Promise<SwaggerResponse<UserDto[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    apiUsersPost(user?: UserDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersPost(_response));
        });
    }

    protected processApiUsersPost(response: Response): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    apiUsersProfileImagePost(user?: UserDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/api/Users/ProfileImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersProfileImagePost(_response));
        });
    }

    protected processApiUsersProfileImagePost(response: Response): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiUsersByIdGet(id: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersByIdGet(_response));
        });
    }

    protected processApiUsersByIdGet(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param user (optional) 
     * @return Success
     */
    apiUsersByIdPut(id: string, user?: UserDto | null | undefined): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersByIdPut(_response));
        });
    }

    protected processApiUsersByIdPut(response: Response): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @return Success
     */
    apiUsersByIdDelete(id: string): Promise<SwaggerResponse<UserDto>> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersByIdDelete(_response));
        });
    }

    protected processApiUsersByIdDelete(response: Response): Promise<SwaggerResponse<UserDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param userId (optional) 
     * @param username (optional) 
     * @return Success
     */
    apiUsersUsernameAvailableGet(userId?: string | null | undefined, username?: string | null | undefined): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/Users/username/available?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersUsernameAvailableGet(_response));
        });
    }

    protected processApiUsersUsernameAvailableGet(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, <any>null));
    }

    /**
     * @param userId (optional) 
     * @param email (optional) 
     * @return Success
     */
    apiUsersEmailAvailableGet(userId?: string | null | undefined, email?: string | null | undefined): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/Users/email/available?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiUsersEmailAvailableGet(_response));
        });
    }

    protected processApiUsersEmailAvailableGet(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ActionItemDto implements IActionItemDto {
    createdOn?: Date | undefined;
    name?: string | undefined;
    assigneeName?: string | undefined;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
    isActive?: boolean | undefined;
    status?: ActionStatusDto | undefined;
    statusId?: string | undefined;
    assessment?: AssessmentDto | undefined;
    assessmentId?: string | undefined;
    description?: string | undefined;
    acceptanceCriteria?: string | undefined;
    completedOn?: Date | undefined;
    bestPractices?: ActionItemBestPracticeDto[] | undefined;
    notes?: NoteDto[] | undefined;
    actionItemAttachmentFiles?: ActionItemAttachmentFileDto[] | undefined;
    id?: string | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;

    constructor(data?: IActionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.name = data["name"];
            this.assigneeName = data["assigneeName"];
            this.assigneeEmail = data["assigneeEmail"];
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.status = data["status"] ? ActionStatusDto.fromJS(data["status"]) : <any>undefined;
            this.statusId = data["statusId"];
            this.assessment = data["assessment"] ? AssessmentDto.fromJS(data["assessment"]) : <any>undefined;
            this.assessmentId = data["assessmentId"];
            this.description = data["description"];
            this.acceptanceCriteria = data["acceptanceCriteria"];
            this.completedOn = data["completedOn"] ? new Date(data["completedOn"].toString()) : <any>undefined;
            if (data["bestPractices"] && data["bestPractices"].constructor === Array) {
                this.bestPractices = [];
                for (let item of data["bestPractices"])
                    this.bestPractices.push(ActionItemBestPracticeDto.fromJS(item));
            }
            if (data["notes"] && data["notes"].constructor === Array) {
                this.notes = [];
                for (let item of data["notes"])
                    this.notes.push(NoteDto.fromJS(item));
            }
            if (data["actionItemAttachmentFiles"] && data["actionItemAttachmentFiles"].constructor === Array) {
                this.actionItemAttachmentFiles = [];
                for (let item of data["actionItemAttachmentFiles"])
                    this.actionItemAttachmentFiles.push(ActionItemAttachmentFileDto.fromJS(item));
            }
            this.id = data["id"];
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["assigneeName"] = this.assigneeName;
        data["assigneeEmail"] = this.assigneeEmail;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        data["assessmentId"] = this.assessmentId;
        data["description"] = this.description;
        data["acceptanceCriteria"] = this.acceptanceCriteria;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        if (this.bestPractices && this.bestPractices.constructor === Array) {
            data["bestPractices"] = [];
            for (let item of this.bestPractices)
                data["bestPractices"].push(item.toJSON());
        }
        if (this.notes && this.notes.constructor === Array) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        if (this.actionItemAttachmentFiles && this.actionItemAttachmentFiles.constructor === Array) {
            data["actionItemAttachmentFiles"] = [];
            for (let item of this.actionItemAttachmentFiles)
                data["actionItemAttachmentFiles"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IActionItemDto {
    createdOn?: Date | undefined;
    name?: string | undefined;
    assigneeName?: string | undefined;
    assigneeEmail?: string | undefined;
    dueDate?: Date | undefined;
    isActive?: boolean | undefined;
    status?: ActionStatusDto | undefined;
    statusId?: string | undefined;
    assessment?: AssessmentDto | undefined;
    assessmentId?: string | undefined;
    description?: string | undefined;
    acceptanceCriteria?: string | undefined;
    completedOn?: Date | undefined;
    bestPractices?: ActionItemBestPracticeDto[] | undefined;
    notes?: NoteDto[] | undefined;
    actionItemAttachmentFiles?: ActionItemAttachmentFileDto[] | undefined;
    id?: string | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
}

export class ActionStatusDto implements IActionStatusDto {
    sortOrder?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IActionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sortOrder = data["sortOrder"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ActionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IActionStatusDto {
    sortOrder?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class AssessmentDto implements IAssessmentDto {
    assessment?: string | undefined;
    targetBranchName?: string | undefined;
    regionName?: string | undefined;
    observerCount?: number | undefined;
    targetBranch?: BranchDto | undefined;
    comparisonBranches?: IdentifierEntityDto[] | undefined;
    kpis?: IdentifierEntityDto[] | undefined;
    observers?: IdentifierEntityDto[] | undefined;
    visitStartedOn?: Date | undefined;
    visitEndedOn?: Date | undefined;
    dueDate?: Date | undefined;
    completedOn?: Date | undefined;
    improvementStrategy?: string | undefined;
    improvementGoals?: string | undefined;
    history?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assessment = data["assessment"];
            this.targetBranchName = data["targetBranchName"];
            this.regionName = data["regionName"];
            this.observerCount = data["observerCount"];
            this.targetBranch = data["targetBranch"] ? BranchDto.fromJS(data["targetBranch"]) : <any>undefined;
            if (data["comparisonBranches"] && data["comparisonBranches"].constructor === Array) {
                this.comparisonBranches = [];
                for (let item of data["comparisonBranches"])
                    this.comparisonBranches.push(IdentifierEntityDto.fromJS(item));
            }
            if (data["kpis"] && data["kpis"].constructor === Array) {
                this.kpis = [];
                for (let item of data["kpis"])
                    this.kpis.push(IdentifierEntityDto.fromJS(item));
            }
            if (data["observers"] && data["observers"].constructor === Array) {
                this.observers = [];
                for (let item of data["observers"])
                    this.observers.push(IdentifierEntityDto.fromJS(item));
            }
            this.visitStartedOn = data["visitStartedOn"] ? new Date(data["visitStartedOn"].toString()) : <any>undefined;
            this.visitEndedOn = data["visitEndedOn"] ? new Date(data["visitEndedOn"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : <any>undefined;
            this.completedOn = data["completedOn"] ? new Date(data["completedOn"].toString()) : <any>undefined;
            this.improvementStrategy = data["improvementStrategy"];
            this.improvementGoals = data["improvementGoals"];
            this.history = data["history"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment;
        data["targetBranchName"] = this.targetBranchName;
        data["regionName"] = this.regionName;
        data["observerCount"] = this.observerCount;
        data["targetBranch"] = this.targetBranch ? this.targetBranch.toJSON() : <any>undefined;
        if (this.comparisonBranches && this.comparisonBranches.constructor === Array) {
            data["comparisonBranches"] = [];
            for (let item of this.comparisonBranches)
                data["comparisonBranches"].push(item.toJSON());
        }
        if (this.kpis && this.kpis.constructor === Array) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        if (this.observers && this.observers.constructor === Array) {
            data["observers"] = [];
            for (let item of this.observers)
                data["observers"].push(item.toJSON());
        }
        data["visitStartedOn"] = this.visitStartedOn ? this.visitStartedOn.toISOString() : <any>undefined;
        data["visitEndedOn"] = this.visitEndedOn ? this.visitEndedOn.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["improvementStrategy"] = this.improvementStrategy;
        data["improvementGoals"] = this.improvementGoals;
        data["history"] = this.history;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAssessmentDto {
    assessment?: string | undefined;
    targetBranchName?: string | undefined;
    regionName?: string | undefined;
    observerCount?: number | undefined;
    targetBranch?: BranchDto | undefined;
    comparisonBranches?: IdentifierEntityDto[] | undefined;
    kpis?: IdentifierEntityDto[] | undefined;
    observers?: IdentifierEntityDto[] | undefined;
    visitStartedOn?: Date | undefined;
    visitEndedOn?: Date | undefined;
    dueDate?: Date | undefined;
    completedOn?: Date | undefined;
    improvementStrategy?: string | undefined;
    improvementGoals?: string | undefined;
    history?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ActionItemBestPracticeDto implements IActionItemBestPracticeDto {
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    bestPracticeId?: string | undefined;
    bestPractice?: BestPracticeDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IActionItemBestPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionItemId = data["actionItemId"];
            this.actionItem = data["actionItem"] ? ActionItemDto.fromJS(data["actionItem"]) : <any>undefined;
            this.bestPracticeId = data["bestPracticeId"];
            this.bestPractice = data["bestPractice"] ? BestPracticeDto.fromJS(data["bestPractice"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ActionItemBestPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionItemBestPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionItemId"] = this.actionItemId;
        data["actionItem"] = this.actionItem ? this.actionItem.toJSON() : <any>undefined;
        data["bestPracticeId"] = this.bestPracticeId;
        data["bestPractice"] = this.bestPractice ? this.bestPractice.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IActionItemBestPracticeDto {
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    bestPracticeId?: string | undefined;
    bestPractice?: BestPracticeDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class NoteDto implements INoteDto {
    creator?: IdentifierEntityDto | undefined;
    text?: string | undefined;
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creator = data["creator"] ? IdentifierEntityDto.fromJS(data["creator"]) : <any>undefined;
            this.text = data["text"];
            this.actionItemId = data["actionItemId"];
            this.actionItem = data["actionItem"] ? ActionItemDto.fromJS(data["actionItem"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["actionItemId"] = this.actionItemId;
        data["actionItem"] = this.actionItem ? this.actionItem.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface INoteDto {
    creator?: IdentifierEntityDto | undefined;
    text?: string | undefined;
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ActionItemAttachmentFileDto implements IActionItemAttachmentFileDto {
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    attachmentFileId?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IActionItemAttachmentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionItemId = data["actionItemId"];
            this.actionItem = data["actionItem"] ? ActionItemDto.fromJS(data["actionItem"]) : <any>undefined;
            this.attachmentFileId = data["attachmentFileId"];
            this.attachmentFile = data["attachmentFile"] ? AttachmentFileDto.fromJS(data["attachmentFile"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ActionItemAttachmentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionItemAttachmentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionItemId"] = this.actionItemId;
        data["actionItem"] = this.actionItem ? this.actionItem.toJSON() : <any>undefined;
        data["attachmentFileId"] = this.attachmentFileId;
        data["attachmentFile"] = this.attachmentFile ? this.attachmentFile.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IActionItemAttachmentFileDto {
    actionItemId?: string | undefined;
    actionItem?: ActionItemDto | undefined;
    attachmentFileId?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class BranchDto implements IBranchDto {
    branch?: string | undefined;
    region?: RegionDto | undefined;
    regionName?: string | undefined;
    distributorCode?: string | undefined;
    distributor?: string | undefined;
    generalManager?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branch = data["branch"];
            this.region = data["region"] ? RegionDto.fromJS(data["region"]) : <any>undefined;
            this.regionName = data["regionName"];
            this.distributorCode = data["distributorCode"];
            this.distributor = data["distributor"];
            this.generalManager = data["generalManager"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["regionName"] = this.regionName;
        data["distributorCode"] = this.distributorCode;
        data["distributor"] = this.distributor;
        data["generalManager"] = this.generalManager;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBranchDto {
    branch?: string | undefined;
    region?: RegionDto | undefined;
    regionName?: string | undefined;
    distributorCode?: string | undefined;
    distributor?: string | undefined;
    generalManager?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class IdentifierEntityDto implements IIdentifierEntityDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IIdentifierEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): IdentifierEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifierEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IIdentifierEntityDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class BestPracticeDto implements IBestPracticeDto {
    name?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    attachmentFileId?: string | undefined;
    id?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IBestPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.attachmentFile = data["attachmentFile"] ? AttachmentFileDto.fromJS(data["attachmentFile"]) : <any>undefined;
            this.attachmentFileId = data["attachmentFileId"];
            this.id = data["id"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): BestPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BestPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attachmentFile"] = this.attachmentFile ? this.attachmentFile.toJSON() : <any>undefined;
        data["attachmentFileId"] = this.attachmentFileId;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBestPracticeDto {
    name?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    attachmentFileId?: string | undefined;
    id?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class AttachmentFileDto implements IAttachmentFileDto {
    url?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAttachmentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.mimeType = data["mimeType"];
            this.content = data["content"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AttachmentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["mimeType"] = this.mimeType;
        data["content"] = this.content;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAttachmentFileDto {
    url?: string | undefined;
    mimeType?: string | undefined;
    content?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class RegionDto implements IRegionDto {
    region?: string | undefined;
    champions?: IdentifierEntityDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"];
            if (data["champions"] && data["champions"].constructor === Array) {
                this.champions = [];
                for (let item of data["champions"])
                    this.champions.push(IdentifierEntityDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        if (this.champions && this.champions.constructor === Array) {
            data["champions"] = [];
            for (let item of this.champions)
                data["champions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IRegionDto {
    region?: string | undefined;
    champions?: IdentifierEntityDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class AffinityClusterDto implements IAffinityClusterDto {
    assessmentId?: string | undefined;
    assessment?: IdentifierEntityDto | undefined;
    observations?: ObservationDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAffinityClusterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assessmentId = data["assessmentId"];
            this.assessment = data["assessment"] ? IdentifierEntityDto.fromJS(data["assessment"]) : <any>undefined;
            if (data["observations"] && data["observations"].constructor === Array) {
                this.observations = [];
                for (let item of data["observations"])
                    this.observations.push(ObservationDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AffinityClusterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffinityClusterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        if (this.observations && this.observations.constructor === Array) {
            data["observations"] = [];
            for (let item of this.observations)
                data["observations"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAffinityClusterDto {
    assessmentId?: string | undefined;
    assessment?: IdentifierEntityDto | undefined;
    observations?: ObservationDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ObservationDto implements IObservationDto {
    createdOn?: Date | undefined;
    isActive?: boolean | undefined;
    observerName?: string | undefined;
    typeName?: string | undefined;
    affinityClusterId?: string | undefined;
    assessmentId?: string | undefined;
    behaviorId?: string | undefined;
    observationDescription?: string | undefined;
    observationType?: ObservationTypeDto | undefined;
    observer?: IdentifierEntityDto | undefined;
    observationAttachmentFiles?: ObservationAttachmentFileDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;

    constructor(data?: IObservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.observerName = data["observerName"];
            this.typeName = data["typeName"];
            this.affinityClusterId = data["affinityClusterId"];
            this.assessmentId = data["assessmentId"];
            this.behaviorId = data["behaviorId"];
            this.observationDescription = data["observationDescription"];
            this.observationType = data["observationType"] ? ObservationTypeDto.fromJS(data["observationType"]) : <any>undefined;
            this.observer = data["observer"] ? IdentifierEntityDto.fromJS(data["observer"]) : <any>undefined;
            if (data["observationAttachmentFiles"] && data["observationAttachmentFiles"].constructor === Array) {
                this.observationAttachmentFiles = [];
                for (let item of data["observationAttachmentFiles"])
                    this.observationAttachmentFiles.push(ObservationAttachmentFileDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ObservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["observerName"] = this.observerName;
        data["typeName"] = this.typeName;
        data["affinityClusterId"] = this.affinityClusterId;
        data["assessmentId"] = this.assessmentId;
        data["behaviorId"] = this.behaviorId;
        data["observationDescription"] = this.observationDescription;
        data["observationType"] = this.observationType ? this.observationType.toJSON() : <any>undefined;
        data["observer"] = this.observer ? this.observer.toJSON() : <any>undefined;
        if (this.observationAttachmentFiles && this.observationAttachmentFiles.constructor === Array) {
            data["observationAttachmentFiles"] = [];
            for (let item of this.observationAttachmentFiles)
                data["observationAttachmentFiles"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IObservationDto {
    createdOn?: Date | undefined;
    isActive?: boolean | undefined;
    observerName?: string | undefined;
    typeName?: string | undefined;
    affinityClusterId?: string | undefined;
    assessmentId?: string | undefined;
    behaviorId?: string | undefined;
    observationDescription?: string | undefined;
    observationType?: ObservationTypeDto | undefined;
    observer?: IdentifierEntityDto | undefined;
    observationAttachmentFiles?: ObservationAttachmentFileDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
}

export class ObservationTypeDto implements IObservationTypeDto {
    observationTypeName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IObservationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.observationTypeName = data["observationTypeName"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ObservationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationTypeName"] = this.observationTypeName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IObservationTypeDto {
    observationTypeName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ObservationAttachmentFileDto implements IObservationAttachmentFileDto {
    observationId?: string | undefined;
    observation?: ObservationDto | undefined;
    attachmentFileId?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IObservationAttachmentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.observationId = data["observationId"];
            this.observation = data["observation"] ? ObservationDto.fromJS(data["observation"]) : <any>undefined;
            this.attachmentFileId = data["attachmentFileId"];
            this.attachmentFile = data["attachmentFile"] ? AttachmentFileDto.fromJS(data["attachmentFile"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ObservationAttachmentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationAttachmentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationId"] = this.observationId;
        data["observation"] = this.observation ? this.observation.toJSON() : <any>undefined;
        data["attachmentFileId"] = this.attachmentFileId;
        data["attachmentFile"] = this.attachmentFile ? this.attachmentFile.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IObservationAttachmentFileDto {
    observationId?: string | undefined;
    observation?: ObservationDto | undefined;
    attachmentFileId?: string | undefined;
    attachmentFile?: AttachmentFileDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class BehaviorDto implements IBehaviorDto {
    stepId?: string | undefined;
    displayOrder?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IBehaviorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stepId = data["stepId"];
            this.displayOrder = data["displayOrder"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): BehaviorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BehaviorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["displayOrder"] = this.displayOrder;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBehaviorDto {
    stepId?: string | undefined;
    displayOrder?: number | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class StepDto implements IStepDto {
    chevronId?: string | undefined;
    skipped?: boolean | undefined;
    displayOrder?: number | undefined;
    behaviors?: BehaviorDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chevronId = data["chevronId"];
            this.skipped = data["skipped"];
            this.displayOrder = data["displayOrder"];
            if (data["behaviors"] && data["behaviors"].constructor === Array) {
                this.behaviors = [];
                for (let item of data["behaviors"])
                    this.behaviors.push(BehaviorDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): StepDto {
        data = typeof data === 'object' ? data : {};
        let result = new StepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chevronId"] = this.chevronId;
        data["skipped"] = this.skipped;
        data["displayOrder"] = this.displayOrder;
        if (this.behaviors && this.behaviors.constructor === Array) {
            data["behaviors"] = [];
            for (let item of this.behaviors)
                data["behaviors"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IStepDto {
    chevronId?: string | undefined;
    skipped?: boolean | undefined;
    displayOrder?: number | undefined;
    behaviors?: BehaviorDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class File implements IFile {
    name?: string | undefined;
    fullName?: string | undefined;
    folderName?: string | undefined;
    directory?: IDirectory | undefined;
    extension?: string | undefined;
    exists?: boolean | undefined;
    additionalAttributes?: FileInfo | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.folderName = data["folderName"];
            this.directory = data["directory"] ? IDirectory.fromJS(data["directory"]) : <any>undefined;
            this.extension = data["extension"];
            this.exists = data["exists"];
            this.additionalAttributes = data["additionalAttributes"] ? FileInfo.fromJS(data["additionalAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["folderName"] = this.folderName;
        data["directory"] = this.directory ? this.directory.toJSON() : <any>undefined;
        data["extension"] = this.extension;
        data["exists"] = this.exists;
        data["additionalAttributes"] = this.additionalAttributes ? this.additionalAttributes.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFile {
    name?: string | undefined;
    fullName?: string | undefined;
    folderName?: string | undefined;
    directory?: IDirectory | undefined;
    extension?: string | undefined;
    exists?: boolean | undefined;
    additionalAttributes?: FileInfo | undefined;
}

export class IDirectory implements IIDirectory {
    name?: string | undefined;
    fullName?: string | undefined;
    exists?: boolean | undefined;
    subDirectories?: IDirectory[] | undefined;
    subDirectoriesRecursive?: IDirectory[] | undefined;
    files?: IFile[] | undefined;
    filesRecursive?: IFile[] | undefined;

    constructor(data?: IIDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.exists = data["exists"];
            if (data["subDirectories"] && data["subDirectories"].constructor === Array) {
                this.subDirectories = [];
                for (let item of data["subDirectories"])
                    this.subDirectories.push(IDirectory.fromJS(item));
            }
            if (data["subDirectoriesRecursive"] && data["subDirectoriesRecursive"].constructor === Array) {
                this.subDirectoriesRecursive = [];
                for (let item of data["subDirectoriesRecursive"])
                    this.subDirectoriesRecursive.push(IDirectory.fromJS(item));
            }
            if (data["files"] && data["files"].constructor === Array) {
                this.files = [];
                for (let item of data["files"])
                    this.files.push(IFile.fromJS(item));
            }
            if (data["filesRecursive"] && data["filesRecursive"].constructor === Array) {
                this.filesRecursive = [];
                for (let item of data["filesRecursive"])
                    this.filesRecursive.push(IFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IDirectory {
        data = typeof data === 'object' ? data : {};
        let result = new IDirectory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["exists"] = this.exists;
        if (this.subDirectories && this.subDirectories.constructor === Array) {
            data["subDirectories"] = [];
            for (let item of this.subDirectories)
                data["subDirectories"].push(item.toJSON());
        }
        if (this.subDirectoriesRecursive && this.subDirectoriesRecursive.constructor === Array) {
            data["subDirectoriesRecursive"] = [];
            for (let item of this.subDirectoriesRecursive)
                data["subDirectoriesRecursive"].push(item.toJSON());
        }
        if (this.files && this.files.constructor === Array) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (this.filesRecursive && this.filesRecursive.constructor === Array) {
            data["filesRecursive"] = [];
            for (let item of this.filesRecursive)
                data["filesRecursive"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIDirectory {
    name?: string | undefined;
    fullName?: string | undefined;
    exists?: boolean | undefined;
    subDirectories?: IDirectory[] | undefined;
    subDirectoriesRecursive?: IDirectory[] | undefined;
    files?: IFile[] | undefined;
    filesRecursive?: IFile[] | undefined;
}

export class FileInfo implements IFileInfo {
    length?: number | undefined;
    directoryName?: string | undefined;
    directory?: DirectoryInfo | undefined;
    isReadOnly?: boolean | undefined;
    fullName?: string | undefined;
    extension?: string | undefined;
    name?: string | undefined;
    exists?: boolean | undefined;
    creationTime?: Date | undefined;
    creationTimeUtc?: Date | undefined;
    lastAccessTime?: Date | undefined;
    lastAccessTimeUtc?: Date | undefined;
    lastWriteTime?: Date | undefined;
    lastWriteTimeUtc?: Date | undefined;
    attributes?: FileInfoAttributes | undefined;

    constructor(data?: IFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.length = data["length"];
            this.directoryName = data["directoryName"];
            this.directory = data["directory"] ? DirectoryInfo.fromJS(data["directory"]) : <any>undefined;
            this.isReadOnly = data["isReadOnly"];
            this.fullName = data["fullName"];
            this.extension = data["extension"];
            this.name = data["name"];
            this.exists = data["exists"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creationTimeUtc = data["creationTimeUtc"] ? new Date(data["creationTimeUtc"].toString()) : <any>undefined;
            this.lastAccessTime = data["lastAccessTime"] ? new Date(data["lastAccessTime"].toString()) : <any>undefined;
            this.lastAccessTimeUtc = data["lastAccessTimeUtc"] ? new Date(data["lastAccessTimeUtc"].toString()) : <any>undefined;
            this.lastWriteTime = data["lastWriteTime"] ? new Date(data["lastWriteTime"].toString()) : <any>undefined;
            this.lastWriteTimeUtc = data["lastWriteTimeUtc"] ? new Date(data["lastWriteTimeUtc"].toString()) : <any>undefined;
            this.attributes = data["attributes"];
        }
    }

    static fromJS(data: any): FileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["directoryName"] = this.directoryName;
        data["directory"] = this.directory ? this.directory.toJSON() : <any>undefined;
        data["isReadOnly"] = this.isReadOnly;
        data["fullName"] = this.fullName;
        data["extension"] = this.extension;
        data["name"] = this.name;
        data["exists"] = this.exists;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["lastAccessTime"] = this.lastAccessTime ? this.lastAccessTime.toISOString() : <any>undefined;
        data["lastAccessTimeUtc"] = this.lastAccessTimeUtc ? this.lastAccessTimeUtc.toISOString() : <any>undefined;
        data["lastWriteTime"] = this.lastWriteTime ? this.lastWriteTime.toISOString() : <any>undefined;
        data["lastWriteTimeUtc"] = this.lastWriteTimeUtc ? this.lastWriteTimeUtc.toISOString() : <any>undefined;
        data["attributes"] = this.attributes;
        return data; 
    }
}

export interface IFileInfo {
    length?: number | undefined;
    directoryName?: string | undefined;
    directory?: DirectoryInfo | undefined;
    isReadOnly?: boolean | undefined;
    fullName?: string | undefined;
    extension?: string | undefined;
    name?: string | undefined;
    exists?: boolean | undefined;
    creationTime?: Date | undefined;
    creationTimeUtc?: Date | undefined;
    lastAccessTime?: Date | undefined;
    lastAccessTimeUtc?: Date | undefined;
    lastWriteTime?: Date | undefined;
    lastWriteTimeUtc?: Date | undefined;
    attributes?: FileInfoAttributes | undefined;
}

export class IFile implements IIFile {
    name?: string | undefined;
    fullName?: string | undefined;
    folderName?: string | undefined;
    directory?: IDirectory | undefined;
    extension?: string | undefined;
    exists?: boolean | undefined;
    additionalAttributes?: FileInfo | undefined;

    constructor(data?: IIFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.folderName = data["folderName"];
            this.directory = data["directory"] ? IDirectory.fromJS(data["directory"]) : <any>undefined;
            this.extension = data["extension"];
            this.exists = data["exists"];
            this.additionalAttributes = data["additionalAttributes"] ? FileInfo.fromJS(data["additionalAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IFile {
        data = typeof data === 'object' ? data : {};
        let result = new IFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["folderName"] = this.folderName;
        data["directory"] = this.directory ? this.directory.toJSON() : <any>undefined;
        data["extension"] = this.extension;
        data["exists"] = this.exists;
        data["additionalAttributes"] = this.additionalAttributes ? this.additionalAttributes.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIFile {
    name?: string | undefined;
    fullName?: string | undefined;
    folderName?: string | undefined;
    directory?: IDirectory | undefined;
    extension?: string | undefined;
    exists?: boolean | undefined;
    additionalAttributes?: FileInfo | undefined;
}

export class DirectoryInfo implements IDirectoryInfo {
    parent?: DirectoryInfo | undefined;
    root?: DirectoryInfo | undefined;
    fullName?: string | undefined;
    extension?: string | undefined;
    name?: string | undefined;
    exists?: boolean | undefined;
    creationTime?: Date | undefined;
    creationTimeUtc?: Date | undefined;
    lastAccessTime?: Date | undefined;
    lastAccessTimeUtc?: Date | undefined;
    lastWriteTime?: Date | undefined;
    lastWriteTimeUtc?: Date | undefined;
    attributes?: DirectoryInfoAttributes | undefined;

    constructor(data?: IDirectoryInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parent = data["parent"] ? DirectoryInfo.fromJS(data["parent"]) : <any>undefined;
            this.root = data["root"] ? DirectoryInfo.fromJS(data["root"]) : <any>undefined;
            this.fullName = data["fullName"];
            this.extension = data["extension"];
            this.name = data["name"];
            this.exists = data["exists"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creationTimeUtc = data["creationTimeUtc"] ? new Date(data["creationTimeUtc"].toString()) : <any>undefined;
            this.lastAccessTime = data["lastAccessTime"] ? new Date(data["lastAccessTime"].toString()) : <any>undefined;
            this.lastAccessTimeUtc = data["lastAccessTimeUtc"] ? new Date(data["lastAccessTimeUtc"].toString()) : <any>undefined;
            this.lastWriteTime = data["lastWriteTime"] ? new Date(data["lastWriteTime"].toString()) : <any>undefined;
            this.lastWriteTimeUtc = data["lastWriteTimeUtc"] ? new Date(data["lastWriteTimeUtc"].toString()) : <any>undefined;
            this.attributes = data["attributes"];
        }
    }

    static fromJS(data: any): DirectoryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["root"] = this.root ? this.root.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["extension"] = this.extension;
        data["name"] = this.name;
        data["exists"] = this.exists;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["lastAccessTime"] = this.lastAccessTime ? this.lastAccessTime.toISOString() : <any>undefined;
        data["lastAccessTimeUtc"] = this.lastAccessTimeUtc ? this.lastAccessTimeUtc.toISOString() : <any>undefined;
        data["lastWriteTime"] = this.lastWriteTime ? this.lastWriteTime.toISOString() : <any>undefined;
        data["lastWriteTimeUtc"] = this.lastWriteTimeUtc ? this.lastWriteTimeUtc.toISOString() : <any>undefined;
        data["attributes"] = this.attributes;
        return data; 
    }
}

export interface IDirectoryInfo {
    parent?: DirectoryInfo | undefined;
    root?: DirectoryInfo | undefined;
    fullName?: string | undefined;
    extension?: string | undefined;
    name?: string | undefined;
    exists?: boolean | undefined;
    creationTime?: Date | undefined;
    creationTimeUtc?: Date | undefined;
    lastAccessTime?: Date | undefined;
    lastAccessTimeUtc?: Date | undefined;
    lastWriteTime?: Date | undefined;
    lastWriteTimeUtc?: Date | undefined;
    attributes?: DirectoryInfoAttributes | undefined;
}

export class ObserverDto implements IObserverDto {
    observerName?: string | undefined;
    observerEmail?: string | undefined;
    observerId?: string | undefined;

    constructor(data?: IObserverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.observerName = data["observerName"];
            this.observerEmail = data["observerEmail"];
            this.observerId = data["observerId"];
        }
    }

    static fromJS(data: any): ObserverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObserverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observerName"] = this.observerName;
        data["observerEmail"] = this.observerEmail;
        data["observerId"] = this.observerId;
        return data; 
    }
}

export interface IObserverDto {
    observerName?: string | undefined;
    observerEmail?: string | undefined;
    observerId?: string | undefined;
}

export class AssessmentProcessDto implements IAssessmentProcessDto {
    assessment?: string | undefined;
    chevrons?: ChevronDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IAssessmentProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assessment = data["assessment"];
            if (data["chevrons"] && data["chevrons"].constructor === Array) {
                this.chevrons = [];
                for (let item of data["chevrons"])
                    this.chevrons.push(ChevronDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): AssessmentProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment;
        if (this.chevrons && this.chevrons.constructor === Array) {
            data["chevrons"] = [];
            for (let item of this.chevrons)
                data["chevrons"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAssessmentProcessDto {
    assessment?: string | undefined;
    chevrons?: ChevronDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ChevronDto implements IChevronDto {
    chevron?: string | undefined;
    displayOrder?: number | undefined;
    steps?: StepDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IChevronDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chevron = data["chevron"];
            this.displayOrder = data["displayOrder"];
            if (data["steps"] && data["steps"].constructor === Array) {
                this.steps = [];
                for (let item of data["steps"])
                    this.steps.push(StepDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): ChevronDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChevronDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chevron"] = this.chevron;
        data["displayOrder"] = this.displayOrder;
        if (this.steps && this.steps.constructor === Array) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IChevronDto {
    chevron?: string | undefined;
    displayOrder?: number | undefined;
    steps?: StepDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class DashboardObservationStatsDto implements IDashboardObservationStatsDto {
    assessmentId?: string | undefined;
    affinityClusterObservationStats?: AffinityClusterObservationStatsDto[] | undefined;
    observationStats?: ObservationStatsDto[] | undefined;

    constructor(data?: IDashboardObservationStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assessmentId = data["assessmentId"];
            if (data["affinityClusterObservationStats"] && data["affinityClusterObservationStats"].constructor === Array) {
                this.affinityClusterObservationStats = [];
                for (let item of data["affinityClusterObservationStats"])
                    this.affinityClusterObservationStats.push(AffinityClusterObservationStatsDto.fromJS(item));
            }
            if (data["observationStats"] && data["observationStats"].constructor === Array) {
                this.observationStats = [];
                for (let item of data["observationStats"])
                    this.observationStats.push(ObservationStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardObservationStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardObservationStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentId"] = this.assessmentId;
        if (this.affinityClusterObservationStats && this.affinityClusterObservationStats.constructor === Array) {
            data["affinityClusterObservationStats"] = [];
            for (let item of this.affinityClusterObservationStats)
                data["affinityClusterObservationStats"].push(item.toJSON());
        }
        if (this.observationStats && this.observationStats.constructor === Array) {
            data["observationStats"] = [];
            for (let item of this.observationStats)
                data["observationStats"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboardObservationStatsDto {
    assessmentId?: string | undefined;
    affinityClusterObservationStats?: AffinityClusterObservationStatsDto[] | undefined;
    observationStats?: ObservationStatsDto[] | undefined;
}

export class AffinityClusterObservationStatsDto implements IAffinityClusterObservationStatsDto {
    affinityClusterName?: string | undefined;
    observationStats?: ObservationStatsDto[] | undefined;

    constructor(data?: IAffinityClusterObservationStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.affinityClusterName = data["affinityClusterName"];
            if (data["observationStats"] && data["observationStats"].constructor === Array) {
                this.observationStats = [];
                for (let item of data["observationStats"])
                    this.observationStats.push(ObservationStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AffinityClusterObservationStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffinityClusterObservationStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affinityClusterName"] = this.affinityClusterName;
        if (this.observationStats && this.observationStats.constructor === Array) {
            data["observationStats"] = [];
            for (let item of this.observationStats)
                data["observationStats"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAffinityClusterObservationStatsDto {
    affinityClusterName?: string | undefined;
    observationStats?: ObservationStatsDto[] | undefined;
}

export class ObservationStatsDto implements IObservationStatsDto {
    observationType?: string | undefined;
    numObservations?: number | undefined;

    constructor(data?: IObservationStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.observationType = data["observationType"];
            this.numObservations = data["numObservations"];
        }
    }

    static fromJS(data: any): ObservationStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationType"] = this.observationType;
        data["numObservations"] = this.numObservations;
        return data; 
    }
}

export interface IObservationStatsDto {
    observationType?: string | undefined;
    numObservations?: number | undefined;
}

export class BranchKpiDto implements IBranchKpiDto {
    branchKpi?: string | undefined;
    value?: number | undefined;
    branch?: IdentifierEntityDto | undefined;
    kpi?: IdentifierEntityDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IBranchKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchKpi = data["branchKpi"];
            this.value = data["value"];
            this.branch = data["branch"] ? IdentifierEntityDto.fromJS(data["branch"]) : <any>undefined;
            this.kpi = data["kpi"] ? IdentifierEntityDto.fromJS(data["kpi"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): BranchKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchKpi"] = this.branchKpi;
        data["value"] = this.value;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["kpi"] = this.kpi ? this.kpi.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBranchKpiDto {
    branchKpi?: string | undefined;
    value?: number | undefined;
    branch?: IdentifierEntityDto | undefined;
    kpi?: IdentifierEntityDto | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ColumnSettingsDto implements IColumnSettingsDto {
    id?: string | undefined;
    isActive?: boolean | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isVisible?: boolean | undefined;
    fieldName?: string | undefined;
    groupOrder?: number | undefined;
    columnName?: string | undefined;
    sort?: string | undefined;
    type?: string | undefined;
    applicationUserId?: string | undefined;

    constructor(data?: IColumnSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isVisible = data["isVisible"];
            this.fieldName = data["fieldName"];
            this.groupOrder = data["groupOrder"];
            this.columnName = data["columnName"];
            this.sort = data["sort"];
            this.type = data["type"];
            this.applicationUserId = data["applicationUserId"];
        }
    }

    static fromJS(data: any): ColumnSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["fieldName"] = this.fieldName;
        data["groupOrder"] = this.groupOrder;
        data["columnName"] = this.columnName;
        data["sort"] = this.sort;
        data["type"] = this.type;
        data["applicationUserId"] = this.applicationUserId;
        return data; 
    }
}

export interface IColumnSettingsDto {
    id?: string | undefined;
    isActive?: boolean | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isVisible?: boolean | undefined;
    fieldName?: string | undefined;
    groupOrder?: number | undefined;
    columnName?: string | undefined;
    sort?: string | undefined;
    type?: string | undefined;
    applicationUserId?: string | undefined;
}

export class KpiDto implements IKpiDto {
    kpi?: string | undefined;
    shortName?: string | undefined;
    description?: string | undefined;
    lowerLimit?: number | undefined;
    upperLimit?: number | undefined;
    kpiType?: KpiTypeDto | undefined;
    kpiTypeName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kpi = data["kpi"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            this.lowerLimit = data["lowerLimit"];
            this.upperLimit = data["upperLimit"];
            this.kpiType = data["kpiType"] ? KpiTypeDto.fromJS(data["kpiType"]) : <any>undefined;
            this.kpiTypeName = data["kpiTypeName"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): KpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpi"] = this.kpi;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["lowerLimit"] = this.lowerLimit;
        data["upperLimit"] = this.upperLimit;
        data["kpiType"] = this.kpiType ? this.kpiType.toJSON() : <any>undefined;
        data["kpiTypeName"] = this.kpiTypeName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IKpiDto {
    kpi?: string | undefined;
    shortName?: string | undefined;
    description?: string | undefined;
    lowerLimit?: number | undefined;
    upperLimit?: number | undefined;
    kpiType?: KpiTypeDto | undefined;
    kpiTypeName?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class KpiTypeDto implements IKpiTypeDto {
    kpiType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IKpiTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kpiType = data["kpiType"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): KpiTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiType"] = this.kpiType;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IKpiTypeDto {
    kpiType?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class LoginDto implements ILoginDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    resetPasswordToken?: string | undefined;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.email = data["email"];
            this.password = data["password"];
            this.resetPasswordToken = data["resetPasswordToken"];
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["resetPasswordToken"] = this.resetPasswordToken;
        return data; 
    }
}

export interface ILoginDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    resetPasswordToken?: string | undefined;
}

export class UserDto implements IUserDto {
    profileImageUrl?: string | undefined;
    profileImageMimeType?: string | undefined;
    profileImageName?: string | undefined;
    profileImageContent?: string | undefined;
    name?: string | undefined;
    userName?: string | undefined;
    oldPassword?: string | undefined;
    password?: string | undefined;
    daysUntilPasswordExpires?: number | undefined;
    jobTitle?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    deactivatedOn?: Date | undefined;
    organization?: SimpleEntityDto | undefined;
    roles?: string[] | undefined;
    isLocked?: boolean | undefined;
    organizationId?: string | undefined;
    id?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profileImageUrl = data["profileImageUrl"];
            this.profileImageMimeType = data["profileImageMimeType"];
            this.profileImageName = data["profileImageName"];
            this.profileImageContent = data["profileImageContent"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.oldPassword = data["oldPassword"];
            this.password = data["password"];
            this.daysUntilPasswordExpires = data["daysUntilPasswordExpires"];
            this.jobTitle = data["jobTitle"];
            this.phoneNumber = data["phoneNumber"];
            this.address = data["address"];
            this.city = data["city"];
            this.state = data["state"];
            this.zipCode = data["zipCode"];
            this.deactivatedOn = data["deactivatedOn"] ? new Date(data["deactivatedOn"].toString()) : <any>undefined;
            this.organization = data["organization"] ? SimpleEntityDto.fromJS(data["organization"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(item);
            }
            this.isLocked = data["isLocked"];
            this.organizationId = data["organizationId"];
            this.id = data["id"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.email = data["email"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileImageUrl"] = this.profileImageUrl;
        data["profileImageMimeType"] = this.profileImageMimeType;
        data["profileImageName"] = this.profileImageName;
        data["profileImageContent"] = this.profileImageContent;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["oldPassword"] = this.oldPassword;
        data["password"] = this.password;
        data["daysUntilPasswordExpires"] = this.daysUntilPasswordExpires;
        data["jobTitle"] = this.jobTitle;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["deactivatedOn"] = this.deactivatedOn ? this.deactivatedOn.toISOString() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isLocked"] = this.isLocked;
        data["organizationId"] = this.organizationId;
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IUserDto {
    profileImageUrl?: string | undefined;
    profileImageMimeType?: string | undefined;
    profileImageName?: string | undefined;
    profileImageContent?: string | undefined;
    name?: string | undefined;
    userName?: string | undefined;
    oldPassword?: string | undefined;
    password?: string | undefined;
    daysUntilPasswordExpires?: number | undefined;
    jobTitle?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    deactivatedOn?: Date | undefined;
    organization?: SimpleEntityDto | undefined;
    roles?: string[] | undefined;
    isLocked?: boolean | undefined;
    organizationId?: string | undefined;
    id?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean | undefined;
}

export class SimpleEntityDto implements ISimpleEntityDto {
    id?: string | undefined;
    isActive?: boolean | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    name?: string | undefined;

    constructor(data?: ISimpleEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SimpleEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data; 
    }
}

export interface ISimpleEntityDto {
    id?: string | undefined;
    isActive?: boolean | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    name?: string | undefined;
}

export class OrganizationDto implements IOrganizationDto {
    organization?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organization = data["organization"];
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization;
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IOrganizationDto {
    organization?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class PasswordRuleSettings implements IPasswordRuleSettings {
    requiredLength?: number | undefined;
    requireDigit?: boolean | undefined;
    requireLowercase?: boolean | undefined;
    requireUppercase?: boolean | undefined;
    requireNonAlphanumeric?: boolean | undefined;
    passwordLifespanInDays?: string | undefined;

    constructor(data?: IPasswordRuleSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requiredLength = data["requiredLength"];
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireUppercase = data["requireUppercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.passwordLifespanInDays = data["passwordLifespanInDays"];
        }
    }

    static fromJS(data: any): PasswordRuleSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordRuleSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredLength"] = this.requiredLength;
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireUppercase"] = this.requireUppercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["passwordLifespanInDays"] = this.passwordLifespanInDays;
        return data; 
    }
}

export interface IPasswordRuleSettings {
    requiredLength?: number | undefined;
    requireDigit?: boolean | undefined;
    requireLowercase?: boolean | undefined;
    requireUppercase?: boolean | undefined;
    requireNonAlphanumeric?: boolean | undefined;
    passwordLifespanInDays?: string | undefined;
}

export class RejectionFormDto implements IRejectionFormDto {
    workOrderNumber?: string | undefined;
    qpn?: string | undefined;
    discoveredBy?: string | undefined;
    discoveredDuring?: string | undefined;
    discoveredQuantity?: number | undefined;
    discoveredDate?: Date | undefined;
    dispositionAuthor?: string | undefined;
    dispositionDate?: Date | undefined;
    useAsIs?: boolean | undefined;
    retestRequired?: boolean | undefined;
    teamLeader?: string | undefined;
    defectCode?: string | undefined;
    adminTime?: number | undefined;
    reworkTime?: number | undefined;
    testedTime?: number | undefined;
    inspectedTime?: number | undefined;
    totalTime?: number | undefined;
    reworkCost?: number | undefined;
    primaryResponsible?: ResponsibleDto | undefined;
    responsible?: ResponsibleDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IRejectionFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workOrderNumber = data["workOrderNumber"];
            this.qpn = data["qpn"];
            this.discoveredBy = data["discoveredBy"];
            this.discoveredDuring = data["discoveredDuring"];
            this.discoveredQuantity = data["discoveredQuantity"];
            this.discoveredDate = data["discoveredDate"] ? new Date(data["discoveredDate"].toString()) : <any>undefined;
            this.dispositionAuthor = data["dispositionAuthor"];
            this.dispositionDate = data["dispositionDate"] ? new Date(data["dispositionDate"].toString()) : <any>undefined;
            this.useAsIs = data["useAsIs"];
            this.retestRequired = data["retestRequired"];
            this.teamLeader = data["teamLeader"];
            this.defectCode = data["defectCode"];
            this.adminTime = data["adminTime"];
            this.reworkTime = data["reworkTime"];
            this.testedTime = data["testedTime"];
            this.inspectedTime = data["inspectedTime"];
            this.totalTime = data["totalTime"];
            this.reworkCost = data["reworkCost"];
            this.primaryResponsible = data["primaryResponsible"] ? ResponsibleDto.fromJS(data["primaryResponsible"]) : <any>undefined;
            if (data["responsible"] && data["responsible"].constructor === Array) {
                this.responsible = [];
                for (let item of data["responsible"])
                    this.responsible.push(ResponsibleDto.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = data["modifiedOn"] ? new Date(data["modifiedOn"].toString()) : <any>undefined;
            this.deletedOn = data["deletedOn"] ? new Date(data["deletedOn"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): RejectionFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectionFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderNumber"] = this.workOrderNumber;
        data["qpn"] = this.qpn;
        data["discoveredBy"] = this.discoveredBy;
        data["discoveredDuring"] = this.discoveredDuring;
        data["discoveredQuantity"] = this.discoveredQuantity;
        data["discoveredDate"] = this.discoveredDate ? this.discoveredDate.toISOString() : <any>undefined;
        data["dispositionAuthor"] = this.dispositionAuthor;
        data["dispositionDate"] = this.dispositionDate ? this.dispositionDate.toISOString() : <any>undefined;
        data["useAsIs"] = this.useAsIs;
        data["retestRequired"] = this.retestRequired;
        data["teamLeader"] = this.teamLeader;
        data["defectCode"] = this.defectCode;
        data["adminTime"] = this.adminTime;
        data["reworkTime"] = this.reworkTime;
        data["testedTime"] = this.testedTime;
        data["inspectedTime"] = this.inspectedTime;
        data["totalTime"] = this.totalTime;
        data["reworkCost"] = this.reworkCost;
        data["primaryResponsible"] = this.primaryResponsible ? this.primaryResponsible.toJSON() : <any>undefined;
        if (this.responsible && this.responsible.constructor === Array) {
            data["responsible"] = [];
            for (let item of this.responsible)
                data["responsible"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IRejectionFormDto {
    workOrderNumber?: string | undefined;
    qpn?: string | undefined;
    discoveredBy?: string | undefined;
    discoveredDuring?: string | undefined;
    discoveredQuantity?: number | undefined;
    discoveredDate?: Date | undefined;
    dispositionAuthor?: string | undefined;
    dispositionDate?: Date | undefined;
    useAsIs?: boolean | undefined;
    retestRequired?: boolean | undefined;
    teamLeader?: string | undefined;
    defectCode?: string | undefined;
    adminTime?: number | undefined;
    reworkTime?: number | undefined;
    testedTime?: number | undefined;
    inspectedTime?: number | undefined;
    totalTime?: number | undefined;
    reworkCost?: number | undefined;
    primaryResponsible?: ResponsibleDto | undefined;
    responsible?: ResponsibleDto[] | undefined;
    id?: string | undefined;
    name?: string | undefined;
    createdOn?: Date | undefined;
    modifiedOn?: Date | undefined;
    deletedOn?: Date | undefined;
    isActive?: boolean | undefined;
}

export class ResponsibleDto implements IResponsibleDto {
    id?: string | undefined;
    person?: string | undefined;
    department?: string | undefined;

    constructor(data?: IResponsibleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.person = data["person"];
            this.department = data["department"];
        }
    }

    static fromJS(data: any): ResponsibleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsibleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["person"] = this.person;
        data["department"] = this.department;
        return data; 
    }
}

export interface IResponsibleDto {
    id?: string | undefined;
    person?: string | undefined;
    department?: string | undefined;
}

export class RoleDto implements IRoleDto {
    id?: string | undefined;
    name?: string | undefined;
    usersInRole?: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.usersInRole = data["usersInRole"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["usersInRole"] = this.usersInRole;
        return data; 
    }
}

export interface IRoleDto {
    id?: string | undefined;
    name?: string | undefined;
    usersInRole?: number | undefined;
}

export enum FileInfoAttributes {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _16 = 16, 
    _32 = 32, 
    _64 = 64, 
    _128 = 128, 
    _256 = 256, 
    _512 = 512, 
    _1024 = 1024, 
    _2048 = 2048, 
    _4096 = 4096, 
    _8192 = 8192, 
    _16384 = 16384, 
    _32768 = 32768, 
    _131072 = 131072, 
}

export enum DirectoryInfoAttributes {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _16 = 16, 
    _32 = 32, 
    _64 = 64, 
    _128 = 128, 
    _256 = 256, 
    _512 = 512, 
    _1024 = 1024, 
    _2048 = 2048, 
    _4096 = 4096, 
    _8192 = 8192, 
    _16384 = 16384, 
    _32768 = 32768, 
    _131072 = 131072, 
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;
        
    constructor(status: number, headers: { [key: string]: any; }, result: TResult) 
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}


// WEBPACK FOOTER //
// ./src/generated_client.ts